import { CSS } from '@grupoboticario/flora-react'

export const fieldsetCss: CSS = {
  backgroundColor: '#F2F2F2',
  border: '1px solid $medium-light-3',
  borderRadius: '10px',
  padding: '$6',
  marginBottom: '$6'
}

export const sectionTitleCss: CSS = {
  marginBottom: '10px'
}

export const faqTitleCss: CSS = {
  marginBottom: '$4'
}

export const addButtonRowCss: CSS = {
  borderTop: '1px dashed rgba(0, 0, 0, 0.24)',
  padding: '$2',
  marginTop: '$4'
}

export const addButtonCss: CSS = {
  marginTop: '$4'
}
